export * from './esports-teams.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/index.ts